export default "__VITE_ASSET__b4c83bba__"